"use client";

import { c as _c } from "react/compiler-runtime";
import { ChatConversationSchemaType, RealEstateConversationAtributesSchemaType } from "../../../api/schemas";
import { SearchUserSchemaType } from "@/components/modules/user/api/schemas";
import { useIsMobile } from "@/hooks/use-mobile";
import { useModal } from "@/components/providers/modal-provider/ModalProvider";
import { ROUTE_PATHS } from "@/constants/routes";
import { buildUserProfileSlug } from "@/components/modules/user/public-profile/userProfileSlug";
import useSession from "@/hooks/QueryHooks/useSession";
import { useSentPendingConnectionRequests } from "@/components/modules/connections/api/queries/useSentPendingConnectionRequests";
import { usePendingConnectionRequests } from "@/components/modules/connections/api/queries/usePendingConnectionRequests";
import { useConnections } from "@/components/modules/connections/api/queries/useConnections";
import { useCreateConnectionRequestMutation } from "@/components/modules/connections/api/mutations/useCreateConnectionRequestMutation";
import type { FriendshipState } from "@/components/modules/connections/api/schemas";
type Args = {
  userName?: string;
  conversation?: ChatConversationSchemaType;
  user?: SearchUserSchemaType;
  realEstateConversationAtributes?: RealEstateConversationAtributesSchemaType;
};
export function useChatHeader(t0) {
  const $ = _c(16);
  const {
    userName,
    conversation,
    user,
    realEstateConversationAtributes
  } = t0;
  const isMobile = useIsMobile();
  const {
    closeModal
  } = useModal();
  const {
    data: sessionData
  } = useSession();
  const {
    data: sentRequestsData
  } = useSentPendingConnectionRequests();
  const {
    data: receivedRequestsData
  } = usePendingConnectionRequests();
  const {
    data: connectionsData
  } = useConnections();
  const {
    mutate: createConnectionRequest,
    isPending: isCreatingRequest
  } = useCreateConnectionRequestMutation();
  const hasRealEstate = conversation?.realEstate != null || realEstateConversationAtributes !== undefined;
  const realEstateTitle = conversation?.realEstate?.title ?? realEstateConversationAtributes?.title ?? null;
  const otherUserId = conversation?.otherUser?.id ?? user?.id;
  let t1;
  if ($[0] !== otherUserId || $[1] !== userName) {
    t1 = otherUserId ? ROUTE_PATHS.USER_PROFILE(buildUserProfileSlug({
      id: otherUserId,
      name: userName ?? ""
    })) : null;
    $[0] = otherUserId;
    $[1] = userName;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const profileHref = t1;
  let t2;
  bb0: {
    if (!sessionData?.id) {
      t2 = "anonymous";
      break bb0;
    }
    if (otherUserId && otherUserId === sessionData.id) {
      t2 = "self";
      break bb0;
    }
    const isFriendFromConversation = conversation?.isFriend === true;
    const isFriendFromConnections = !!(otherUserId && connectionsData?.data?.some(c => c.id === otherUserId));
    if (isFriendFromConversation || isFriendFromConnections) {
      t2 = "friends";
      break bb0;
    }
    const hasPendingSent = !!sentRequestsData?.data?.some(req => req.recipientId === otherUserId);
    const hasPendingReceived = !!receivedRequestsData?.data?.some(req_0 => req_0.senderId === otherUserId);
    if (hasPendingSent || hasPendingReceived) {
      t2 = "pending";
      break bb0;
    }
    t2 = "none";
  }
  const friendshipState = t2;
  let t3;
  if ($[3] !== createConnectionRequest || $[4] !== otherUserId || $[5] !== userName) {
    t3 = () => {
      if (!otherUserId) {
        return;
      }
      createConnectionRequest({
        connectionUserId: otherUserId,
        recipientName: userName ?? undefined
      });
    };
    $[3] = createConnectionRequest;
    $[4] = otherUserId;
    $[5] = userName;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const sendFriendRequest = t3;
  let t4;
  if ($[7] !== closeModal || $[8] !== friendshipState || $[9] !== hasRealEstate || $[10] !== isCreatingRequest || $[11] !== isMobile || $[12] !== profileHref || $[13] !== realEstateTitle || $[14] !== sendFriendRequest) {
    t4 = {
      isMobile,
      closeModal,
      hasRealEstate,
      realEstateTitle,
      profileHref,
      friendshipState,
      sendFriendRequest,
      isCreatingRequest
    };
    $[7] = closeModal;
    $[8] = friendshipState;
    $[9] = hasRealEstate;
    $[10] = isCreatingRequest;
    $[11] = isMobile;
    $[12] = profileHref;
    $[13] = realEstateTitle;
    $[14] = sendFriendRequest;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
}